export const CONST_TERMS_OF_USE = 1;
export const CONST_REFUND_POLICY = 2;
export const CONST_BILLING_POLICY = 3;
export const CONST_PRIVACY_POLICY = 4;
export const CONST_COOKIE_POLICY = 5;
export const CONST_RISKS_NOTICE = 6;
export const CONST_DISCLOSURES_DISCLAIMERS = 7;
